import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';

import en from './i18n/en.json';
import tr from './i18n/tr.json';
import ar from './i18n/ar.json';
import ir from './i18n/ir.json';

Vue.use(VueI18n);

// set a locale code for each domain
const languages = {
  'soorbakalim.com': 'tr',
  'selfiemyself.com': 'en',
  'aktashafnafsak.co': 'ar',
  'madefourme.com': 'en',
  'aktashafmananta.com': 'ar',
  'khodshenasi.co': 'ir',
};

// get domain name from url
const domain = window.location.host.replace(/^www\./, '');

// get locale of the entered domain
const locale = languages[domain] || 'tr';

if (process.env.NODE_ENV === 'production') {
  // store domain
  store.commit('setDomain', domain);
} else {
  store.commit('setDomain', 'soorbakalim.com');
}

export default new VueI18n({
  locale,
  messages: {
    tr,
    en,
    ar,
    ir,
  },
});
